var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"grey6",attrs:{"fab":"","text":"","small":""}},[_c('div',{staticClass:"d-flex text-18 grey3--text"},[_c('div',[_vm._v(_vm._s(_vm.$props.daynumber))]),_c('sup',{staticClass:"text-10 orangeMain--text mt-3 bold",domProps:{"textContent":_vm._s(_vm.$props.weekday)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }